import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";

import { Message as MessageProps } from "@/types";

import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import AppTextArea from "@/components/AppTextArea";
import AppLoader from "@/components/AppLoader";
import AppIcon from "@/components/AppIcon";
import AppCard from "@/components/AppCard";
import Message from "@/components/Lead/Messages/Message";

interface AppDialogChatProps {
  messages: MessageProps[]; // Adjust the message shape as needed
  isLoading?: boolean;
  onSubmit: (message: string) => void;
}

const LeadMessages: React.FC<AppDialogChatProps> = ({
  messages,
  isLoading = false,
  onSubmit,
}) => {
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    scrollToBottom(false);
  }, [messages]);

  const scrollToBottom = (smooth: boolean = true) => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: smooth ? "smooth" : "auto",
      });
    }
  };

  const handleSendMessage = () => {
    if (!message.trim()) return;
    setMessage("");
    onSubmit(message);
  };

  return (
    <AppCard className="gap-4">
      <AppText variant="h3">Messages</AppText>

      <AppBox
        column
        fullHeight
        fullWidth
        className="relative h-full overflow-hidden"
      >
        {/* Messages Container */}
        <AppBox
          column
          gap={4}
          className={clsx(
            "overflow-y-auto flex-grow relative"
          )}
        >
          <AppBox column justify="end" gap={4} className="flex-grow">
            {messages?.map((msg) => (
              <Message key={msg.id} message={msg} />
            ))}
          </AppBox>
          {/* Anchor for auto-scroll */}
          <div ref={messagesEndRef}></div>
        </AppBox>

        {/* Chat Input */}
        <AppBox className="pt-2 bg-white">
          <AppTextArea
            value={message}
            onChange={setMessage}
            onSend={handleSendMessage}
            placeholder="Type your message here..."
          />
        </AppBox>
      </AppBox>
      
      {/* <AppBox column fullHeight fullWidth gap={4}>
        <AppBox column gap={4} className="overflow-auto max-h-[300px] xl:max-h-[640px]">
          {messages?.map((message) => (
            <Message key={message.id} message={message} />
          ))}
        </AppBox>

        <AppTextArea
          value={message}
          onChange={setMessage}
          onSend={handleSendMessage}
          placeholder="Type your message here..."
        />
      </AppBox> */}
    </AppCard>
  );
};

export default LeadMessages;